import { IconButton } from '@mui/material';
import React from 'react';
import { CloseIcon } from 'stream-chat-react';

export const CustomDrawer = ({
  children,
  onOpenChange,
  heading,
  width = '',
}: {
  children: React.ReactNode;
  onOpenChange?: any;
  heading: string;
  width?: string; // Accept width as a prop
}) => {
  // const [open];
  return (
    <div className="fixed left-0 top-0 z-50 flex h-screen w-screen items-center justify-end bg-black/20">
      <div
        className="relative h-full max-w-[800px]  overflow-auto rounded-l-2xl bg-white "
        style={{ width }}
      >
        <div
          className="  flex items-center justify-between  p-3 py-2"
          style={{ borderBottom: '1px solid  rgb(0 0 0 / 0.2)' }}
        >
          <div className=" px-2 text-lg font-semibold capitalize">
            {heading || 'Heading'}
          </div>
          <div className="">
            <IconButton
              aria-label="Close"
              onClick={() => onOpenChange(false)}
              className="text-black"
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};
